// Filter.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faUndo } from '@fortawesome/free-solid-svg-icons';

import './Filter.css';

function Filter({
  latestDistrict,
  latestPalika,
  onDistrictChange,
  onPalikaChange,
  isEnglish,
}) {
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [palikas, setPalikas] = useState([]);
  const [selectedPalika, setSelectedPalika] = useState('');

  useEffect(() => {
    // Load the GeoJSON file
    axios
      .get('/supa_palikas.geojson')
      .then((response) => {
        // Extract districts from GeoJSON data
        const uniqueDistricts = Array.from(
          new Set(response.data.features.map((feature) => feature.properties.DISTRICT))
        );
        setDistricts(uniqueDistricts);
      })
      .catch((error) => {
        console.error('Error loading GeoJSON file:', error);
      });
  }, []);

  useEffect(() => {
    // Load PALIKAs based on the selected district or latestDistrict
    const targetDistrict = selectedDistrict || latestDistrict;

    if (targetDistrict) {
      // Fetch data again and use the response
      axios
        .get('/supa_palikas.geojson')
        .then((response) => {
          // Filter features based on the selected district or latestDistrict
          const filteredFeatures = response.data.features.filter(
            (feature) => feature.properties.DISTRICT === targetDistrict
          );

          // Extract PALIKAs from the filtered features
          const uniquePalikas = Array.from(
            new Set(filteredFeatures.map((feature) => feature.properties.GaPa_NaPa))
          );
          setPalikas(uniquePalikas);
        })
        .catch((error) => {
          console.error('Error loading GeoJSON file:', error);
        });
    }
  }, [selectedDistrict, latestDistrict]);

  const handleDistrictChange = (event) => {
    const selectedDistrict = event.target.value;
    setSelectedDistrict(selectedDistrict);
    setSelectedPalika('');

    // Call the callback function to send the latest DISTRICT to the parent component
    onDistrictChange(selectedDistrict);
  };

  const handlePalikaChange = (event) => {
    const selectedPalika = event.target.value;
    setSelectedPalika(selectedPalika);

    // Call the callback function to send the latest PALIKA to the parent component
    onPalikaChange(selectedPalika);
  };

  const handleReset = () => {
    setSelectedDistrict('');
    setSelectedPalika('');
    onDistrictChange('');
    onPalikaChange('');
  };

  const handleExportMap = () => {
    window.print();
  

  
  };

  return (
    <div className="filter-container">
      <select id="district" value={selectedDistrict || latestDistrict} onChange={handleDistrictChange}>
        <option value="">{isEnglish ? 'SELECT DISTRICT' : 'जिल्ला छनौट गर्नुहोस्'}</option>
        {districts.map((district) => (
          <option key={district} value={district}>
            {district}
          </option>
        ))}
      </select>

      <select id="palika" value={selectedPalika || latestPalika} onChange={handlePalikaChange}>
        <option value="">{isEnglish ? 'SELECT PALIKA' : 'पालिका छनौट गर्नुहोस्'}</option>
        {palikas.map((palika) => (
          <option key={palika} value={palika}>
            {palika}
          </option>
        ))}
      </select>

      <button className="reset-button" onClick={handleReset}>
        <FontAwesomeIcon icon={faUndo} />
        {isEnglish ? 'Reset' : 'पुनः सेट गर्नुहोस्'}
      </button>

      <button className="export-button" onClick={handleExportMap}>
        <FontAwesomeIcon icon={faDownload} />
        {isEnglish ? 'Export Map' : 'नक्शा निर्यात गर्नुहोस्'}
      </button>
    </div>
  );
}

export default Filter;
